import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWhatsapp,
  faFacebookF,
  faInstagram,
  faSnapchatGhost,
} from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer>
      <div className="container">
        <div className="shadow bg-white rounded-3 w-100 p-md-5 p-3">
          <div className="row align-items-center">
            <div className="col-md-6 mb-2 mb-md-0 text-center">
              <h5 className="subscribe-title m-0">{t('footer.subscribe_title')}</h5>
            </div>
            <div className="col-md-6">
              <div className="d-flex align-items-center position-relative">
                <input
                  type="email"
                  className="form-control py-md-3 py-2 w-100"
                  placeholder={t('footer.subscribe_placeholder')}
                />
                <button className="contact-btn subscribe-btn px-4 rounded-1 py-md-2 py-1">
                  {t('footer.subscribe_btn')}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row align-items-center mt-5">
          <div className="col-md-6 mb-3">
            <div className="d-flex gap-2 justify-content-between align-items-center flex-wrap">
              <a className="footer-nav" href="#home" rel="noreferrer">
                {t('nav.home')}
              </a>
              <a className="footer-nav" href="#about" rel="noreferrer">
                {t('nav.about')}
              </a>
              <a className="footer-nav text-nowrap" href="#why-us" rel="noreferrer">
                {t('nav.why_us')}
              </a>
              <a className="footer-nav" href="#contact" rel="noreferrer">
                {t('nav.contact')}
              </a>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="d-flex gap-4 justify-content-end align-items-center social-icons">
              <a href="https://wa.me/971509590424" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} />
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
              <a href="https://snapchat.com" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faSnapchatGhost} />
              </a>
            </div>
          </div>
        </div>

        <div className="row align-items-center border-top pt-4 mt-2">
          <div className="col-md-6 mb-3">
            <p className="copyright mt-3">
              {t('footer.created_by', { name: 'Ahmed Ali' })}
            </p>
          </div>

          <div className="col-md-6 mb-3">
            <div className="d-flex gap-4 justify-content-end align-items-center flex-wrap">
              <a href="/terms" rel="noreferrer" className="copyright">
                {t('footer.terms')}
              </a>
              <a href="/privacy" rel="noreferrer" className="copyright">
                {t('footer.privacy')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
